<template>
  <AppHeader />
  <div class="container">
    <IntroSection />
    <LocationSection />
    <EquipmentSection />
    <ProductsSection />
  </div>
  <AppFooter />
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import IntroSection from './components/IntroSection.vue'
import LocationSection from './components/LocationSection.vue'
import EquipmentSection from './components/EquipmentSection.vue'
import ProductsSection from './components/ProductsSection.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    IntroSection,
    LocationSection,
    EquipmentSection,
    ProductsSection
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
  min-height: 100vh;
  min-width: 100vw;
  background: black;
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  font-size: 20pt;
  color: white;
  display: flex;
  flex-direction: column;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

header {
  height: 60%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(rgb(100, 100, 100), rgb(55, 55, 55), black);
}

header > h1 {
  font-size: 72pt;
  font-weight: 400;
}

h2 {
  font-size: 42pt;
  padding: 0;
  padding-top: 1em;
  padding-bottom: 5px;
  margin: 0;
}

p.simple_p {
  padding: 1em 0;
  margin: 0;
}

.container {
  margin: 0 5em;
  height: 40%;
}

.intro {
  display: flex;
  align-items: center;
  margin: 1em 0;
}

.intro > div {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
}

#image {
  flex: 1;
}

#image > img {
  width: 100%;
}

#info {
  flex: 2;
  text-align: left;
  align-items: start;
  padding: 0 1em;
  background: none;
}

#contact {
  list-style: none;
  padding: 0;
  margin: 0 1em;
}

#contact > li {
  padding: 5px 0;
}

#location {
  display: flex;
  flex-direction: column;
}

.maps {
  height: 350px;
  width: 100%;
}

#equipment {
  display: flex;
  flex-direction: column;
}

.list-grid {
  display: grid;
  grid-template-columns: auto auto auto auto;
  column-gap: 5px;
  row-gap: 1em;
}

.list-grid > div {
  border: 1px solid whitesmoke;
  border-radius: 5px;
  padding: 1em;
}

.grid-item {
  display: flex;
  flex-direction: column;
}

.grid-item-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid whitesmoke;
  border-radius: 5px;
}

.grid-item-caption {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#produce {
  margin: 1em 0;
}

.list-flex {
  display: flex;
  align-items: center;
}

.list-flex > div {
  flex: 1;
  margin: 0 5px;
  border: 1px solid whitesmoke;
  border-radius: 5px;
  padding: 1em;
}

footer {
  padding: 2em 0;
  text-align: center;
  font-size: 10pt;
}

a.contact {
  text-decoration: none;
  color: teal;
}

/* Mobile Styling */
@media screen and (max-width: 500px) {
  header > h1 {
    font-size: 30pt;
  }

  .container {
    margin: 0 1em;
  }

  .list-grid {
    grid-template-columns: auto;
  }

  .simple_p {
    font-size: 12pt;
  }

  h2 {
    font-size: 26pt;
  }

  .intro {
    flex-direction: column;
  }

  #image {
    flex: 1;
    width: 80%;
  }

  #info {
    flex: 1;
  }

  #info > p {
    font-size: 11pt;
  }

  #contact {
    margin: 0 5px;
  }

  #contact > li {
    font-size: 12pt;
  }

  .grid-item-caption {
    font-size: 12pt;
  }
}
</style>
